module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114139_101_157.6c83293.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114139_101_157.jpg
// module id = Scy+
// module chunks = 0